var URLQuery = [];

var startApp = function() {
    var containerDom = document.getElementById('interactive-area');

    var webApp = new CC.WebApp(containerDom, 640, 960);
    webApp.screenWidthMax = 640;
    webApp.screenWidthMin = 640;
    webApp.screenHeightMax = 1136;
    webApp.screenHeightMin = 853;

    PIXI.AUTO_PREVENT_DEFAULT = true;
    webApp.backgroundColor = 0xFFFFFF;
    webApp.firstStart(Screens.loadingScreen(),(!CC.isMobile || CC.isKindle));
    webApp.cssEnabled = true;
    //if(CC.isMobile)
    {
        webApp.resizeMethod = CC.WebApp.Resizer.FLEX_HEIGHT;
    }

    Interface.startFocusListener();
    if(CC.isMobile){
        // var noSleep = new NoSleep();
        // function enableNoSleep() {
        //     noSleep.enable();
        //     document.removeEventListener('touchstart', enableNoSleep, false);
        // }
        // document.addEventListener('touchstart', enableNoSleep, false);

/*
        if (screenfull && screenfull.enabled) {
            var fullscreenFunction = function () {
                screenfull.request();
            };
            interactiveArea.addEventListener("touchstart", fullscreenFunction);
        }
*/
    }
    ccLoader.load();
};